import { createUseStyles } from "react-jss";
import { HeaderHeight } from "../../core";

const { isSaderatCustomization } = JSON.parse(sessionStorage.getItem("config"));

const useStylesHeader = createUseStyles((theme) => ({
  headerRoom: {
    display: process.env.REACT_APP_SHOW_HEADER ? "flex" : "none",
    background: theme.headerBg,
    color: theme.headerFontColor,
    height: HeaderHeight.larg,
    justifyContent: "space-between",
    alignItems: "center",
    padding: [0, 24, 0, 16],
    "& .dropdown-toggle::after": {
      display: "none!important",
    },
    "& .dropdown-item:active": {
      backgroundColor: theme.headerBg,
    },
    borderTopRightRadius: process.env.REACT_APP_PROJECT === "widget" ? 10 : 0,
    borderTopLeftRadius: process.env.REACT_APP_PROJECT === "widget" ? 10 : 0,
    // position: "fixed",
    width: "100%",
    zIndex: 1,
    borderBottom: "1px solid #EEF0F2",
  },
  "@media screen and (max-width: 687px) ": {
    headerRoom: {
      height: HeaderHeight.small,
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0,
    },
  },
  toggleHeader: {
    width: 208,
    height: 40,
    background: `${
      isSaderatCustomization ? theme.roomButtonBgSaderat : theme.roomButtonBg
    }!important`,
    color: `${theme.answerBubbleColor}!important`,
    fontSize: theme.messageFontSize,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
  },
  toggleHeaderDots: {
    width: "52px",
    height: "52px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    border: "none!important",
    borderRadius: "50%",
    "&:focus": {
      border: "none!important",
      boxShadow: "none!important",
    },
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#F4F6F8",
    },
    "& *": {
      fontSize: theme.fontSize,
    },
  },
  roomsMenu: {
    width: 208,
    border: "1px solid rgba(216, 220, 224, 0.38)",
    textAlign: "right",
    "& *": {
      fontSize: theme.messageFontSize,
    },
  },
  roomItem: {
    height: 36,
    color: "#3A3F49",
    "&:hover": {
      backgroundColor: "#F6F8FA",
    },
    "&:focus": {
      color: "#3A3F49",
    },
  },
  dropdownIcon: {
    marginRight: 10,
    marginBottom: 8,
    width: 24,
    height: 24,
  },
  //   login header
  closeBtn: {
    marginLeft: 10,
    cursor: "pointer",
    color: "white",
  },
  changeFont: {
    background: `${theme.headerBg}!important`,
    color: `${theme.headerDotColor}!important`,
    border: "none!important",
    padding: 0,
    marginLeft: 10,
  },
  nestedMenu: {
    fontSize: `${theme.messageFontSize}!important`,
    "& *": {
      fontSize: `${theme.messageFontSize}!important`,
    },
  },
  menu: {
    "& .MuiPaper-elevation8": {
      boxShadow: "0px 4px 13px 0px #D8DCE01F",
      border: "1px solid #D8DCE061",
      borderRadius: 10,
      padding: 8,
      direction: "rtl",
    },
    "& li": {
      borderRadius: 5,
      padding: 8,
      "&:hover": {
        backgroundColor: "#E5EEFF",
      },
    },
    "& .MuiList-padding": {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  menuIcon: {
    marginInlineEnd: 8,
  },
  fontsMenuItem: {
    padding: "0px!important",
  },
  fontsContent: {
    display: "flex",
    flexDirection: "column",
  },
  fontsToggleBox: {
    minWidth: 193,
    display: "flex",
    justifyContent: "space-between",
    padding: 8,
    svg: {
      transition: "all 0.5s",
    },
  },
  fontsBox: {
    width: "100%",
    backgroundColor: "#F4F6F8",
    borderRadius: 5,
    padding: "4px 8px",
    display: "flex",
    justifyContent: "space-between",
    gap: 4,
    "& $span": {
      backgroundColor: "white",
      borderRadius: 2,
      padding: "2px 8px",
      fontSize: 12,
    },
  },
  selectedFont: {
    border: "1px solid #5F636C",
  },
  singleRoomHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    "& $span": {
      color: "#202733",
      fontWeight: 500,
    },
  },
}));
export default useStylesHeader;
